// Single source of truth for clinic display constants used across the frontend.
// Sensitive values stay in backend env; these are public display values only.

export const CLINIC_WHATSAPP = "919057535251";

export const CLINIC_PHONES = [
  { display: "+91 90575 35251", tel: "+919057535251" },
  { display: "+91 75196 61963", tel: "+917519661963" },
  { display: "+91 91351 62053", tel: "+919135162053" },
];

export const CLINIC_PRIMARY_PHONE = CLINIC_PHONES[0];

export const CLINIC_DOMAIN = "thedentalclinicbydrashish.com";
export const CLINIC_DOMAIN_URL = `https://${CLINIC_DOMAIN}`;

export const CLINIC_EMAIL = "hello@thedentalclinicbydrashish.com";

export const CLINIC_ADDRESS = {
  line1: "Pakri More, Gaushala Road",
  line2: "Siwan, Bihar",
  landmark: "20 Ft North from V2 Mall",
};

export const CLINIC_HOURS = {
  days: "Mon – Sun",
  time: "9:00 AM – 8:00 PM",
};

export const CLINIC_GEO = { lat: 26.2345278, lng: 84.3693889 };

// Google Business Profile (verified listing for "The Dental Clinic" in Siwan).
// FtID from Maps URL: 0x3992fdcf419bed5b:0x367313dc271a5812 → CID 3923501536639604754
export const GOOGLE_BUSINESS_URL = "https://www.google.com/maps/place/?cid=3923501536639604754";
// Use the FtID-embedded directions URL so Google locks onto "The Dental Clinic"
// instead of snapping to a neighbouring POI when only coords are given.
export const GOOGLE_DIRECTIONS_URL = "https://www.google.com/maps/dir//The+Dental+Clinic,+North+from+V2+Mall,+Pakri+More,+20+Ft,+Gaushala+Rd,+Siwan,+Bihar+841226/data=!4m8!4m7!1m0!1m5!1m1!1s0x3992fdcf419bed5b:0x367313dc271a5812!2m2!1d84.3693889!2d26.2345278";
export const GOOGLE_REVIEW_URL = "https://www.google.com/maps/place/?cid=3923501536639604754&action=writereview";
export const GOOGLE_MAPS_EMBED_URL = `https://maps.google.com/maps?q=${CLINIC_GEO.lat},${CLINIC_GEO.lng}&z=17&output=embed`;

export const CLINIC_LANGUAGES = ["Hindi", "English", "Bhojpuri"];

export const buildBookingMessage = (appt) => {
  const lines = [
    "*New Appointment Booking* 🦷",
    "",
    `*Patient:* ${appt.name || "-"}`,
    `*Phone:* ${appt.phone || "-"}`,
    `*Service:* ${appt.service || "-"}`,
    `*Date:* ${appt.appointment_date || "-"}`,
    `*Time:* ${appt.appointment_time || "-"}`,
  ];
  if (appt.total_amount != null) lines.push(`*Amount:* ₹${Number(appt.total_amount).toLocaleString("en-IN")}`);
  if (appt.payment_status) lines.push(`*Payment:* ${appt.payment_status === "paid" ? "✅ Paid" : "Pay at clinic"}`);
  if (appt.id) lines.push(`*Booking ID:* ${String(appt.id).slice(0, 8)}`);
  lines.push("", "Please confirm my appointment. Thank you!");
  return lines.join("\n");
};

export const buildWhatsappUrl = (appt, number = CLINIC_WHATSAPP) => {
  return `https://wa.me/${number}?text=${encodeURIComponent(buildBookingMessage(appt))}`;
};

// ---- Admin → Patient confirmation ----
const digitsOnly = (s = "") => String(s).replace(/\D+/g, "");

// Normalise Indian phone numbers to E.164-like digits for wa.me (no +).
export const normalizePatientPhone = (raw) => {
  const d = digitsOnly(raw);
  if (!d) return "";
  if (d.length === 10) return `91${d}`;
  if (d.length === 11 && d.startsWith("0")) return `91${d.slice(1)}`;
  if (d.length === 12 && d.startsWith("91")) return d;
  if (d.length === 13 && d.startsWith("091")) return d.slice(1);
  return d; // leave as-is; wa.me will validate
};

export const buildAdminConfirmationMessage = (appt) => {
  const lines = [
    `Hi ${appt.name || "there"},`,
    "",
    "Your appointment at *The Dental Clinic by Dr. Ashish* is confirmed ✅",
    "",
    `*Service:* ${appt.service || "-"}`,
    `*Date:* ${appt.appointment_date || "-"}`,
    `*Time:* ${appt.appointment_time || "-"}`,
  ];
  if (appt.total_amount != null) {
    const paid = appt.payment_status === "paid";
    lines.push(`*Amount:* ₹${Number(appt.total_amount).toLocaleString("en-IN")} ${paid ? "(Paid ✅)" : "(Pay at clinic)"}`);
  }
  lines.push(
    "",
    `📍 ${CLINIC_ADDRESS.line1}, ${CLINIC_ADDRESS.line2}`,
    `(${CLINIC_ADDRESS.landmark})`,
    "",
    "Please arrive 10 minutes early. Reply here if you need to reschedule.",
    "",
    "— Dr. Ashish Kumar",
  );
  return lines.join("\n");
};

export const buildAdminConfirmationUrl = (appt) => {
  const to = normalizePatientPhone(appt.phone);
  return `https://wa.me/${to}?text=${encodeURIComponent(buildAdminConfirmationMessage(appt))}`;
};
